import { FileText, Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/shared/ui/Button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/shared/ui/Sheet";
import { useInvoiceQuery } from "../hooks/useActivityOperationsQuery";
import { InvoiceDetailBody } from "./InvoiceDetailBody";

type InvoiceDrawerButtonProps = {
  invoiceId: string
  kind?: "avoir" | "facture" | null
};

/**
 * Self-contained trigger that opens a drawer with the linked invoice
 * (facture / avoir). Drop it wherever an entry references a Core::Invoice.
 */
export const InvoiceDrawerButton = ({ invoiceId, kind }: InvoiceDrawerButtonProps) => {
  const [open, setOpen] = useState(false);
  const { data: invoice, isLoading } = useInvoiceQuery(open ? invoiceId : null);

  const isFacture = kind === "facture";
  const label = isFacture ? "Voir la facture" : "Voir l'avoir";

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-6 w-6 p-0"
        onClick={() => setOpen(true)}
        aria-label={label}
        title={label}
      >
        <FileText className="h-3.5 w-3.5" />
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
          <SheetHeader>
            <SheetTitle>{isFacture ? "Facture" : "Avoir"}</SheetTitle>
            <SheetDescription>Écriture rattachée à cette affectation comptable.</SheetDescription>
          </SheetHeader>
          <div className="mt-4">
            {isLoading && (
              <div className="flex items-center justify-center py-10">
                <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
              </div>
            )}
            {invoice && <InvoiceDetailBody invoice={invoice} />}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
